import { Auth } from "aws-amplify";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";

import { ADD_USER, SIGN_OUT } from "../../actionTypes/auth";
import { save, remove } from "../../../../utils/storage";
import { redirectToAuthUI } from "../../../../utils/domusoAuthUI";

export function addUser({ cognitoUser, userInfo, sessionExpired }: any) {
  // console.log("signing in");
  return { type: ADD_USER, payload: { cognitoUser, userInfo, sessionExpired } };
}

export function signOut(sessionExpired = false) {
  return { type: SIGN_OUT, payload: { sessionExpired } };
}

export function signOutUser(sessionExpired = false) {
  if (Platform.OS === "web") {
    return async function (dispatch: any) {
      dispatch(signOut());
      await Auth.signOut();
      localStorage.clear();
      redirectToAuthUI();
    };
  } else {
    return async function (dispatch: any) {
      dispatch(signOut(sessionExpired));
      await Auth.signOut();
      await AsyncStorage.clear();
    };
  }
}

export function addUserTokensToStorage({ idToken, accessToken, refreshToken }: ITokens) {
  return async function () {
    await save("cognitoTokens", { idToken, accessToken, refreshToken });
  };
}

// export function addUserAsync({ cognitoUser, userInfo }: any) {
//   // https://github.com/aws-amplify/amplify-js/issues/4351#issuecomment-566800254
//   return async (dispatch) => {
//     // Probably should have a loading state
//     const cognitoUser = await Auth.currentAuthenticatedUser();
//     const currentSession = await Auth.currentSession();
//     return await new Promise((resolve, reject) => {
//       cognitoUser.refreshSession(currentSession?.refreshToken, (err, session) => {
//         if (err) {
//           reject(err);
//         }
//         return resolve(session.idToken.jwtToken);
//       });
//     });
//   };
// }
